module.exports = __webpack_public_path__ + "img/sub-nav-links-default.76de9d2f.png";